/**
 * Remove preceding and succeeding slashes from a string
 * @param  {String} string Something like "/test" or "/path/"
 * @returns {String} The string without beginning or ending slashes
 */
export default string => string.replace(/^\/+|\/+$/g, '');
